module.exports = __webpack_public_path__ + "img/TailWing-Assembly_II.6e98265a.jpg";